import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=dba6ddb4&scoped=true&"
import script from "./FooterContent.vue?vue&type=script&lang=js&"
export * from "./FooterContent.vue?vue&type=script&lang=js&"
import style0 from "./FooterContent.vue?vue&type=style&index=0&id=dba6ddb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba6ddb4",
  null
  
)

export default component.exports